module.exports = __webpack_public_path__ + "static/media/vhv_logo.bde00046.jpeg";